import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./CareerPage.css";
import { useAssets } from "../assets/AssetsContext";
import toast, { Toaster } from "react-hot-toast";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// import { Form } from "react-bootstrap";

import { useParams } from "react-router-dom";
// import ContactPatch3 from "./images/Awards-img-2.png";
import Timestamp from "react-timestamp";
import DOMPurify from "dompurify";

// Mock data for career posts - normally this would come from an API

function Careers() {
  const assets = useAssets();
  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    AOS.refresh();
  }, []);

  const careerPostsData = [
    {
      id: 1,
      title: "Senior EDI Architect",
      jobType: "Full Time",
      shortDescription:
        "As an EDI Architect, you will be responsible for leading the design, development, and implementation of Electronic Data Interchange (EDI) solutions for our clients...",
      fullContent: `
    <h3>Job Summary:</h3>
    <p>As an EDI Architect, you will be responsible for leading the design, development, and implementation of Electronic Data Interchange (EDI) solutions for our clients. You will work closely with business stakeholders, developers, and technical teams to gather requirements, design EDI workflows, and ensure the successful integration of EDI systems with existing business processes and systems. The ideal candidate is a seasoned EDI professional with a deep understanding of industry standards and best practices.</p>
    
    <h3>Responsibilities:</h3>
    <ul>
      <li><strong>Requirement Analysis:</strong> Collaborate with stakeholders to gather and document EDI requirements.</li>
      <li><strong>EDI Solution Design:</strong> Design EDI solutions and create architecture diagrams.</li>
      <li><strong>EDI Standards Compliance:</strong> Ensure alignment with ANSI X12, EDIFACT, XML, HIPAA, GDPR.</li>
      <li><strong>Data Mapping and Transformation:</strong> Develop transformation scripts and ensure efficient mapping.</li>
      <li><strong>Integration with Business Systems:</strong> Integrate EDI with ERP, CRM, and enterprise systems.</li>
      <li><strong>EDI Communication Protocols:</strong> Configure and manage AS2, SFTP, FTPS, VANs.</li>
      <li><strong>EDI Trading Partner Management:</strong> Onboard partners and manage partner profiles.</li>
      <li><strong>EDI Governance and Compliance:</strong> Implement controls and audits to ensure compliance.</li>
      <li><strong>EDI Performance Optimization:</strong> Tune systems for performance and reliability.</li>
      <li><strong>EDI Monitoring and Support:</strong> Monitor systems and resolve transmission issues.</li>
      <li><strong>EDI Training and Documentation:</strong> Provide training and maintain user guides.</li>
      <li><strong>EDI Project Management:</strong> Lead implementation projects, allocate resources.</li>
      <li><strong>EDI Vendor Management:</strong> Manage vendors and evaluate EDI tools and services.</li>
      <li><strong>Continuous Improvement:</strong> Identify areas to reduce cost and improve service.</li>
      <li><strong>Cross-Functional Collaboration:</strong> Align EDI goals with business units.</li>
    </ul>
    
    <h3>Requirements:</h3>
    <ul>
      <li>Bachelor’s degree in Computer Science, Information Systems, or related field.</li>
      <li>Minimum of 15 years of experience in EDI architecture and design.</li>
      <li>Experience with IBM Sterling, Seeburger BIS, or similar tools.</li>
      <li>Strong knowledge of AS2, SFTP, FTPS, VANs.</li>
      <li>Excellent communication and interpersonal skills.</li>
    </ul>
    
    <p><strong>AccelESG is an Equal Opportunity Employer.</strong> We celebrate diversity and are committed to creating an inclusive environment for all employees...</p>
    
    <p><strong>Job Type:</strong> Full Time</p>
    <p><strong>Location:</strong> US, Remote</p>
    `,
      category: "Architect",
    },
    {
      id: 2,
      title: "Azure Data Architect",
      jobType: "Full Time",
      shortDescription:
        "As an Azure Data Architect, you will play a pivotal role in shaping the data architecture strategy and roadmap for our clients' Azure-based data solutions...",
      fullContent: `
    
    <h3>Job Summary:</h3>
    <p>As an Azure Data Architect, you will play a pivotal role in shaping the data architecture strategy and roadmap for our clients’ Azure-based data solutions. You will work closely with stakeholders, IT teams, and data engineers to design and implement scalable, reliable, and secure data solutions. The ideal candidate has deep expertise in Azure data services and a passion for data innovation.</p>
    
    <h3>Responsibilities:</h3>
    <ul>
      <li><strong>Data Architecture Strategy:</strong> Define architecture vision and roadmap.</li>
      <li><strong>Solution Design:</strong> Lead development of data lakes, warehouses, and streaming platforms.</li>
      <li><strong>Azure Data Services Expertise:</strong> Recommend tools like Synapse, Databricks, Cosmos DB.</li>
      <li><strong>Data Governance and Compliance:</strong> Ensure data quality, lineage, cataloging, and privacy.</li>
      <li><strong>Security and Access Controls:</strong> Implement encryption, access, and compliance mechanisms.</li>
      <li><strong>Performance Optimization:</strong> Use indexing, caching, and tuning techniques.</li>
      <li><strong>Data Integration and ETL/ELT:</strong> Design pipelines using Data Factory, Databricks, etc.</li>
      <li><strong>Collaboration and Stakeholder Engagement:</strong> Gather requirements, present solutions.</li>
      <li><strong>Team Leadership and Mentoring:</strong> Guide engineers and foster continuous learning.</li>
    </ul>
    
    <h3>Requirements:</h3>
    <ul>
      <li>Bachelor’s in Computer Science or related field (Master’s preferred).</li>
      <li>15+ years in data architecture with Azure focus.</li>
      <li>Expertise in Synapse, Databricks, SQL DB, Cosmos DB, Blob Storage.</li>
      <li>Strong skills in data modeling, security, compliance (GDPR, CCPA).</li>
      <li>Azure certifications preferred.</li>
    </ul>
    
    <p><strong>AccelESG is an Equal Opportunity Employer.</strong> We celebrate diversity and are committed to creating an inclusive environment for all employees...</p>
    
    <p><strong>Job Type:</strong> Full Time</p>
    <p><strong>Location:</strong> US, Remote</p>
    `,
      category: "Architect",
    },

    {
      id: 3,
      title: "LeanIX Architect",
      jobType: "Full Time",
      shortDescription:
        "The LeanIX Architect is responsible for developing and maintaining the overall architecture framework for our customers. The role involves collaborating with various stakeholders to understand business needs and providing technical leadership in the design and implementation of enterprise-wide systems.",
      fullContent: `
    <p><strong>Job Summary:</strong> The LeanIX Architect is responsible for developing and maintaining the overall architecture framework for our customers. The role involves collaborating with various stakeholders to understand business needs and providing technical leadership in the design and implementation of enterprise-wide systems.</p>
    
    <h2>Responsibilities:</h2>
    <h3>Strategy and Planning:</h3>
    <ul>
      <li>Develop and deliver long-term strategic goals for enterprise architecture vision and standards.</li>
      <li>Create agile solutions and achieve an overall enterprise architecture roadmap.</li>
      <li>Establish methods for tracking quality, completeness, redundancy, and improvement.</li>
      <li>Conduct capacity planning, feasibility studies, and other tasks.</li>
      <li>Create strategies for security, backup, disaster recovery, and business continuity.</li>
      <li>Ensure compliance with healthcare IT & security regulations.</li>
    </ul>
    
    <h3>Leadership:</h3>
    <ul>
      <li>Collaborate with business leaders and IT teams to align architectural solutions with business goals.</li>
      <li>Guide and mentor junior team members.</li>
      <li>Lead LeanIX implementations and establish governance.</li>
    </ul>
    
    <h3>Stakeholder Collaboration:</h3>
    <ul>
      <li>Understand business requirements and translate them into architectural solutions.</li>
      <li>Communicate with both technical and non-technical stakeholders.</li>
    </ul>
    
    <h3>Operational Management:</h3>
    <ul>
      <li>Oversee governance, stewardship, and framework implementation.</li>
      <li>Implement tools like LeanIX, LucidChart, and Visio.</li>
      <li>Document and maintain enterprise architecture.</li>
    </ul>
    
    <h3>Fast Track EA Success:</h3>
    <ul>
      <li>Create architecture documentation and dashboards.</li>
      <li>Digitize architecture representations and implement workflows.</li>
    </ul>
    
    <h2>Requirements:</h2>
    <ul>
      <li>Bachelor’s or Master’s in Computer Science, IT, or related field.</li>
      <li>Experience as an Enterprise Architect with proficiency in LeanIX and LucidChart.</li>
      <li>Strong analytical, communication, and leadership skills.</li>
    </ul>
    
    <h2>Personal Attributes:</h2>
    <ul>
      <li>Strong interpersonal and communication skills.</li>
      <li>Ability to present ideas clearly and build relationships.</li>
    </ul>
    
    <p><strong>Job Type:</strong> Full Time</p>
    <p><strong>Location:</strong> Atlanta</p>`,
      category: "Architect",
      location: "Atlanta",
      applyNow: "https://www.accel1.com/job/leanix-architect/",
    },

    {
      id: 4,
      title: "Senior LeanIX Engineer",
      jobType: "Full Time",
      shortDescription:
        "As a Senior LeanIX Engineer, you will be responsible for leading the implementation, configuration, and optimization of LeanIX within our customer organization.",
      fullContent: `
    <p><strong>Job Summary:</strong> As a Senior LeanIX Engineer, you will be responsible for leading the implementation, configuration, and optimization of LeanIX within our customer organization. You will work closely with cross-functional teams to gather requirements, design solutions, and deliver outcomes that drive business value.</p>
    
    <h2>Responsibilities:</h2>
    <ul>
      <li>Lead LeanIX implementation, configuration, and integration.</li>
      <li>Define enterprise architecture standards and guidelines.</li>
      <li>Create workflows, data models, and dashboards.</li>
      <li>Provide guidance to team members on best practices.</li>
      <li>Continuously improve LeanIX usage and adoption.</li>
    </ul>
    
    <h2>Requirements:</h2>
    <ul>
      <li>Bachelor’s in CS, IS, or related field (Master’s preferred).</li>
      <li>8+ years in IT consulting, enterprise architecture, or similar.</li>
      <li>Proven LeanIX implementation experience.</li>
      <li>Knowledge of TOGAF and architecture standards.</li>
      <li>Strong communication and stakeholder engagement skills.</li>
    </ul>
    
    <p><strong>AccelESG is an Equal Opportunity Employer.</strong></p>
    
    <p><strong>Job Type:</strong> Full Time</p>
    <p><strong>Location:</strong> Hyderabad, India</p>`,
      category: "Engineer",
      location: "Hyderabad, India",
      applyNow: "https://www.accel1.com/job/senior-leanix-engineer/",
    },

    {
      id: 5,
      title: "Senior MSM (Microsoft Sustainability Manager) Engineer",
      jobType: "Full Time",
      shortDescription:
        "AccelESG is a dynamic and innovative company committed to environmental, social and economic conscious future. We are seeking a highly skilled and motivated Senior MSM Engineer to join our ESG Technology team and play a key role in supporting our customers on their ESG journey.",
      fullContent: `
    <p><strong>Job Summary:</strong> AccelESG is a dynamic and innovative company committed to environmental, social and economic conscious future. We are seeking a highly skilled and motivated Senior MSM Engineer to join our ESG Technology team and play a key role in supporting our customers on their ESG journey.</p>
    
    <h2>Responsibilities:</h2>
    <h3>System Integration:</h3>
    <ul>
      <li>Design, implement, and maintain MSM solutions for ESG reporting.</li>
      <li>Integrate MSM with other systems for seamless data flow.</li>
    </ul>
    
    <h3>Process Automation:</h3>
    <ul>
      <li>Automate ESG processes to improve efficiency.</li>
      <li>Identify and implement process improvements.</li>
    </ul>
    
    <h3>Platform Configuration:</h3>
    <ul>
      <li>Customize MSM to meet business requirements.</li>
      <li>Optimize platform for performance and scalability.</li>
    </ul>
    
    <h3>Collaboration:</h3>
    <ul>
      <li>Work with finance, IT, and stakeholders to gather ESG requirements.</li>
    </ul>
    
    <h3>Technical Support:</h3>
    <ul>
      <li>Resolve MSM-related issues promptly.</li>
    </ul>
    
    <h3>Security and Compliance:</h3>
    <ul>
      <li>Implement security measures to protect ESG data.</li>
    </ul>
    
    <h3>Documentation:</h3>
    <ul>
      <li>Create and maintain platform and process documentation.</li>
    </ul>
    
    <h3>Training and Mentorship:</h3>
    <ul>
      <li>Train users and mentor junior team members.</li>
    </ul>
    
    <h3>Continuous Improvement:</h3>
    <ul>
      <li>Keep up with MSM updates and ESG technology trends.</li>
    </ul>
    
    <h3>Project Management:</h3>
    <ul>
      <li>Lead MSM implementation and optimization projects.</li>
    </ul>
    
    <h2>Qualifications:</h2>
    <ul>
      <li>Bachelor’s in CS or related field.</li>
      <li>Experience as an MSM Engineer with ESG focus.</li>
      <li>Strong integration, automation, and configuration skills.</li>
      <li>Excellent communication and problem-solving skills.</li>
    </ul>
    
    <p><strong>AccelESG is an Equal Opportunity Employer.</strong></p>
    
    <p><strong>Job Type:</strong> Full Time</p>
    <p><strong>Location:</strong> Hyderabad, India</p>`,
      category: "Engineer",
      location: "Hyderabad, India",
      applyNow: "https://www.accel1.com/job/senior-msm-engineer/",
    },
    {
      id: 6,
      title: "Senior Azure Data Engineer",
      jobType: "Full Time",
      shortDescription:
        "As a Senior Azure Data Engineer, you will play a key role in designing, implementing, and optimizing data solutions on the Azure platform...",
      fullContent: `
        <h3>Job Summary</h3>
        <p>As a Senior Azure Data Engineer, you will play a key role in designing, implementing, and optimizing data solutions on the Azure platform... </p>
        <h3>Responsibilities</h3>
        <ul>
          <li>Collaborate with customer stakeholders...</li>
          <li>Design and implement end-to-end data pipelines...</li>
          <li>Develop and maintain data ingestion processes...</li>
          <li>Implement data security, governance...</li>
          <li>Optimize data solutions...</li>
          <li>Provide technical leadership...</li>
        </ul>
        <h3>Requirements</h3>
        <ul>
          <li>Bachelor’s degree in Computer Science or related field...</li>
          <li>Minimum of 8 years of experience...</li>
          <li>Strong expertise in Azure Data Factory, Databricks...</li>
          <li>Proficiency in SQL, Python, Scala...</li>
          <li>Hands-on experience with data modeling...</li>
          <li>Excellent communication skills...</li>
          <li>Azure certifications preferred.</li>
        </ul>
        <p><strong>AccelESG is an Equal Opportunity Employer...</strong></p>
        <p><strong>Job Type:</strong> Full Time</p>
        <p><strong>Location:</strong> US, Remote</p>
      `,
      category: "Engineer",
    },
    {
      id: 7,
      title: "Senior PowerBI Engineer",
      jobType: "Full Time",
      shortDescription:
        "As a Power BI Engineer, you will be responsible for designing, developing, and implementing Power BI solutions...",
      fullContent: `
        <h3>Job Summary</h3>
        <p>As a Power BI Engineer, you will be responsible for designing, developing, and implementing Power BI solutions...</p>
        <h3>Responsibilities</h3>
        <ul>
          <li>Collaborate with business stakeholders...</li>
          <li>Design and develop interactive reports...</li>
          <li>Transform raw data into meaningful insights...</li>
          <li>Optimize report performance...</li>
          <li>Implement row-level security...</li>
          <li>Provide training and support to end-users...</li>
        </ul>
        <h3>Requirements</h3>
        <ul>
          <li>Bachelor’s degree in Computer Science or related field...</li>
          <li>Minimum of 8 years of experience...</li>
          <li>Proficiency in Power BI Desktop and Service...</li>
          <li>Experience with DAX, M query, and SQL...</li>
          <li>Strong data visualization and communication skills...</li>
        </ul>
        <p><strong>AccelESG is an Equal Opportunity Employer...</strong></p>
        <p><strong>Job Type:</strong> Full Time</p>
        <p><strong>Location:</strong> Hyderabad, India</p>
      `,
      category: "Engineer",
    },
    {
      id: 8,
      title: "MENA Sales Executive",
      jobType: "Full Time",
      shortDescription:
        "As a MENA Region Sales Executive, you will be responsible for developing and executing sales strategies...",
      fullContent: `
        <h3>Job Summary</h3>
        <p>As a MENA Region Sales Executive, you will be responsible for developing and executing sales strategies...</p>
        <h3>Responsibilities</h3>
        <ul>
          <li>Business Development: Identify and target new business opportunities...</li>
          <li>Client Relationship Management: Build and maintain strong relationships...</li>
          <li>Sales Pipeline Management: Manage the sales pipeline...</li>
          <li>Market Research and Analysis: Conduct research and analysis...</li>
          <li>Sales Forecasting and Reporting: Prepare accurate forecasts and metrics...</li>
          <li>Cross-Functional Collaboration: Work with internal teams...</li>
          <li>Customer Satisfaction and Retention: Ensure high levels of satisfaction...</li>
          <li>Industry Events and Networking: Represent the company at events...</li>
        </ul>
        <h3>Requirements</h3>
        <ul>
          <li>Bachelor’s degree in Business or related field...</li>
          <li>Minimum of 5 years of experience...</li>
          <li>Proven sales success in the MENA market...</li>
          <li>Excellent communication and negotiation skills...</li>
          <li>Fluency in English...</li>
          <li>Willingness to travel...</li>
        </ul>
        <p><strong>AccelESG is an Equal Opportunity Employer...</strong></p>
        <p><strong>Job Type:</strong> Full Time</p>
        <p><strong>Location:</strong> Hyderabad, India</p>
      `,
      category: "Sales",
    },
    {
      id: 9,
      title: "Europe Sales Executive",
      jobType: "Full Time",
      shortDescription:
        "As a Europe Region Sales Executive, you will be responsible for developing and executing sales strategies...",
      fullContent: `
        <h3>Job Summary</h3>
        <p>As a EUROPE Region Sales Executive, you will be responsible for developing and executing sales strategies...</p>
        <h3>Responsibilities</h3>
        <ul>
          <li>Business Development: Identify and target new opportunities...</li>
          <li>Client Relationship Management: Build and manage client relationships...</li>
          <li>Sales Pipeline Management: Prospect, qualify, close deals...</li>
          <li>Market Research and Analysis: Analyze trends and competition...</li>
          <li>Sales Forecasting and Reporting: Track and measure performance...</li>
          <li>Cross-Functional Collaboration: Collaborate with marketing, product teams...</li>
          <li>Customer Satisfaction and Retention: Deliver great service and solve issues...</li>
          <li>Industry Events and Networking: Attend events and trade shows...</li>
        </ul>
        <h3>Requirements</h3>
        <ul>
          <li>Bachelor’s degree in Business or Marketing...</li>
          <li>Minimum of 5 years of experience in Europe region sales...</li>
          <li>Excellent communication and presentation skills...</li>
          <li>Fluency in English...</li>
          <li>Willingness to travel in Europe...</li>
        </ul>
        <p><strong>AccelESG is an Equal Opportunity Employer...</strong></p>
        <p><strong>Job Type:</strong> Full Time</p>
        <p><strong>Location:</strong> Hyderabad, India</p>
      `,
      category: "Sales",
    },
    {
      id: 10,
      title: "Senior Enterprise Architect",
      jobType: "Full Time",
      shortDescription:
        "The Senior Enterprise Architect is responsible for developing and maintaining the overall architecture framework...",
      fullContent: `
        <h3>Job Summary</h3>
        <p>The Senior Enterprise Architect is responsible for developing and maintaining the overall architecture framework...</p>
        <h3>Responsibilities</h3>
        <h4>Strategy and Planning</h4>
        <ul>
          <li>Develop strategic goals for enterprise architecture...</li>
          <li>Create agile solutions and roadmaps...</li>
          <li>Conduct capacity and feasibility studies...</li>
          <li>Ensure compliance with IT & security standards...</li>
        </ul>
        <h4>Leadership</h4>
        <ul>
          <li>Collaborate with business and IT stakeholders...</li>
          <li>Communicate architectural goals across teams...</li>
          <li>Mentor and guide junior architects...</li>
        </ul>
        <h4>Stakeholder Collaboration</h4>
        <ul>
          <li>Translate business needs into architectural solutions...</li>
          <li>Ensure alignment of tech with business strategies...</li>
        </ul>
        <h4>Operational Management</h4>
        <ul>
          <li>Establish governance, stewardship standards...</li>
          <li>Select appropriate enterprise tools...</li>
          <li>Oversee LeanIX and ensure best practices...</li>
        </ul>
        <h4>Fast Track EA Success</h4>
        <ul>
          <li>Document and maintain architecture views...</li>
          <li>Provide architecture training and build dashboards...</li>
        </ul>
        <h3>Requirements</h3>
        <ul>
          <li>Bachelor’s or Master’s in Computer Science or IT...</li>
          <li>Experience with LeanIX and LucidChart...</li>
          <li>Understanding of microservices and cloud architecture...</li>
          <li>Strong problem-solving and analytical skills...</li>
        </ul>
        <p><strong>AccelESG is an Equal Opportunity Employer...</strong></p>
        <p><strong>Job Type:</strong> Full Time</p>
        <p><strong>Location:</strong> US, Remote</p>
      `,
      category: "Architect",
    },
  ];

  const [posts, setPosts] = useState(careerPostsData);
  const [filteredPosts, setFilteredPosts] = useState(careerPostsData);
  const [showModal, setShowModal] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [filterText, setFilterText] = useState(""); // Keep filterText state for potential future use or if other filters need it
  const [selectedCategory, setSelectedCategory] = useState("All"); // Default to 'All'

  // Extract unique categories for the filter dropdown, including 'All'
  const categories = [
    "All",
    ...new Set(careerPostsData.map((post) => post.category)),
  ];

  useEffect(() => {
    let currentFilteredPosts = posts;

    // Apply category filter
    if (selectedCategory && selectedCategory !== "All") {
      currentFilteredPosts = currentFilteredPosts.filter(
        (post) => post.category === selectedCategory
      );
    }

    // Note: The text filter logic remains, but the input field is removed from the UI.
    // If you want to completely remove text filtering functionality, you can remove this block.
    if (filterText) {
      currentFilteredPosts = currentFilteredPosts.filter(
        (post) =>
          post.title.toLowerCase().includes(filterText.toLowerCase()) ||
          post.shortDescription
            .toLowerCase()
            .includes(filterText.toLowerCase()) ||
          post.fullContent.toLowerCase().includes(filterText.toLowerCase())
      );
    }

    setFilteredPosts(currentFilteredPosts);
  }, [filterText, selectedCategory, posts]); // Depend on filter states and original posts

  const handleReadMore = (post) => {
    setSelectedPost(post);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedPost(null);
  };

  const [careerData, setCareerData] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [qualification, setQualification] = useState("");
  const [experience, setExperience] = useState("");
  const [jobCategory, setJobCategory] = useState("");
  const [address, setAddress] = useState("");
  const [otherinformation, setOtherinformation] = useState("");
  const [jobRole, setJobRole] = useState("");
  const [resume, setResume] = useState(null);
  const [careerJobId, setJobId] = useState("");
  const [job, setJob] = useState(null);
  const [errors, setErrors] = useState({});

  const handleJobClick = (job) => {
    setSelectedJob(job); // Set the clicked job
  };

  const closeModal = () => {
    setSelectedJob(null); // Close the modal
  };

  const handleChange = (e, name) => {
    switch (name) {
      case "fname":
        setFname(e.target.value);
        break;
      case "lname":
        setLname(e.target.value);
        break;
      case "email":
        setEmail(e.target.value);
        break;
      case "phone":
        setPhone(e.target.value);
        break;
      case "qualification":
        setQualification(e.target.value);
        break;
      case "experience":
        setExperience(e.target.value);
        break;
      case "address":
        setAddress(e.target.value);
        break;
      case "otherinformation":
        setOtherinformation(e.target.value);
        break;
      case "jobCategory":
        setJobCategory(e.target.value); // Update jobCategory state on change
        break;
      default:
        break;
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Required fields validation
    if (!fname) newErrors.fname = "First Name is required.";
    if (!lname) newErrors.lname = "Last Name is required.";
    if (!email) newErrors.email = "Email is required.";
    if (!phone) newErrors.phone = "Phone Number is required.";
    if (!qualification) newErrors.qualification = "Qualification is required.";
    if (!experience) newErrors.experience = "Experience is required.";
    if (!jobCategory) newErrors.jobCategory = "Job Category is required.";
    if (!address) newErrors.address = "Address is required.";
    if (!resume) newErrors.resume = "Resume upload is required.";

    // Email format validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailPattern.test(email)) {
      newErrors.email = "Invalid email format.";
    }

    // Phone number format validation (example: allow digits only, adjust as needed)
    const phonePattern = /^\d{12}$/; // Assuming 10 digits for phone
    if (phone && !phonePattern.test(phone)) {
      newErrors.phone = "Phone number must be 10 digits.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if there are no errors
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return; // Stop submission if validation fails
    }

    const uploadFile = async () => {
      try {
        const formData = new FormData();
        const timestamp = new Date().toISOString().replace(/[:.-]/g, "");
        const fileWithTimestamp = new File(
          [resume],
          `${timestamp}_${resume.name}`,
          { type: resume.type }
        );

        formData.append("resumefile", fileWithTimestamp);
        formData.append("job_id", careerJobId);

        const response = await fetch(
          "https://accel1.whysocial.in/career-file-upload.php",
          {
            method: "POST",
            body: formData,
          }
        );

        if (response.ok) {
          const data = await response.json();
          console.log("File Upload Response:", data);
          if (data && data.error) {
            console.error("Server Error:", data.error);
            alert(`Upload Error: ${data.error}`);
            return null;
          } else {
            console.log("Uploaded file name:", data.filename);
            return data.filename;
          }
        } else {
          const errorText = await response.text();
          console.error("Server response:", errorText);
          // alert(`Upload failed: ${errorText}`);
          throw new Error("Failed to upload file");
        }
      } catch (error) {
        console.error("Upload error:", error);
        // alert("An error occurred while uploading the file. Please try again.");
        return null;
      }
    };

    const filename = await uploadFile();

    if (!filename) {
      alert("File upload failed. Please try again.");
      return;
    }

    const dataObj = {
      fname,
      lname,
      email,
      phone,
      qualification,
      experience,
      job_category: jobCategory,
      address,
      message: otherinformation,
      // job_id: careerJobId,
      job_id: 0,
      resumefile: filename,
    };
    console.log("dataObj", dataObj);

    const postData = async () => {
      try {
        const response = await fetch(
          "https://accel1.whysocial.in/career-form.php",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataObj),
          }
        );

        alert("response", response);
        console.log("Responseee", response);
        if (response.ok) {
          const data1 = await response.json();
          console.log("Response from post", data1);
          // alert("Form submitted successfully!");
          toast.success("Form submitted successfully!");

          setFname("");
          setLname("");
          setEmail("");
          setPhone("");
          setQualification("");
          setExperience("");
          setJobCategory("");
          setAddress("");
          setOtherinformation("");
          setResume(null);
        } else {
          const errorText = await response.text();
          console.error("Server response:", errorText);
          // alert(`Form submission failed: ${errorText}`);
          toast.error("Form submission failed. Please try again.");
          throw new Error("Failed to submit form");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("An error occurred. Please try again later.");
        // alert("An error occurred while submitting the form. Please try again.");
      }
    };

    await postData();
  };

  const onChangeFileUpload = (e) => {
    const file = e.target.files[0];
    setResume(file);
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  // sw://nfinity.psmprojects.net/career.php

  useEffect(() => {
    const fetchCarrerData = async () => {
      try {
        const response = await fetch("https://accel1.whysocial.in/career.php");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const jsonData = await response.json();
        if (jsonData) {
          const fetchedData = jsonData.map((eachItem) => ({
            id: eachItem.id,
            job_title: eachItem.job_title,
            job_summary: eachItem.job_summary,
            location: eachItem.location,
            jobtype: eachItem.jobtype,
          }));
          console.log("FETCHEDDATA", fetchedData);
          setCareerData(fetchedData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchCarrerData();
  }, []);

  return (
    <>
      {/* <div className="innerbanner-section-1">
        <div className="relative-1">
          <div className="bottom-sec-1 max-width-500 padding-bottom-1">
            <h1 data-aos="zoom-in">Build the Future That Builds the Planet</h1>
            <p data-aos="zoom-in">
              At Accel1, we’re not just hiring for roles—we’re inviting
              collaborators on a mission to engineer climate intelligence at
              scale. If you believe technology should serve ecosystems, equity,
              and impact, we want to hear from you.
            </p>
          </div>
          <img src={assets.leadershipbanner} alt="" data-aos="fade-in" />
        </div>
      </div> */}

      <div className="innerbanner-section-1">
        <div className="relative-1">
          <div className="s2-heading-text">
            <h1 data-aos="zoom-in">Build the Future That Builds the Planet</h1>
            <p data-aos="zoom-in">
              At Accel1, we’re not just hiring for roles—we’re inviting
              collaborators on a mission to engineer climate intelligence at
              scale. If you believe technology should serve ecosystems, equity,
              and impact, we want to hear from you.
            </p>
          </div>
          <img
            src={assets.careerbanner}
            alt=""
            data-aos="fade-in"
            className="d-d"
          />
          <img
            src={assets.careerbanner2}
            alt=""
            data-aos="fade-in"
            className="m-d"
          />
        </div>
      </div>
      <div className="career-page-container">
        {/* Page Header */}
        <h2>Openings</h2>
        <div className="career-p-wrap">
          <div className="career-p-1">
            {/* Tab Menu for Categories */}
            <div className="category-tabs">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`category-tab-button ${
                    selectedCategory === category ? "active" : ""
                  }`}
                >
                  {category === "All" ? "All" : category}
                </button>
              ))}
            </div>
          </div>
          <div className="career-p-2">
            <div className="career-posts-grid">
              {filteredPosts.length > 0 ? (
                filteredPosts.map((post) => (
                  <div key={post.id} className="career-post-card">
                    <div>
                      <h3>{post.title}</h3>
                      <h6 className="job-type">{post.jobType}</h6>
                      <p className="short-description">
                        {post.shortDescription}
                      </p>
                    </div>
                    <div className="career-post-card-footer">
                      <button
                        onClick={() => handleReadMore(post)}
                        className="learn-more"
                      >
                        Learn More
                      </button>
                      {/* <button className="apply-now">Apply Now</button> */}
                      <a className="button-1 apply-now" href="#ApplyNow">
                        Apply Now
                      </a>
                    </div>
                  </div>
                ))
              ) : (
                <p className="no-posts-found">
                  No career opportunities found matching your criteria.
                </p>
              )}
            </div>
          </div>
        </div>

        {/* Filter Section */}

        {/* Removed Search Input */}
        {/*
        <div className="search-input-wrapper">
          <label htmlFor="search-filter" className="sr-only">Search by Keyword</label>
          <input
            id="search-filter"
            type="text"
            placeholder="Search job title or description..."
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            className="search-input"
          />
        </div>
        */}

        {/* Career Posts Grid */}

        {/* Modal Popup */}
        {showModal && selectedPost && (
          <div className="modal-overlay">
            <div className="modal-content animate-modal-in">
              <div className="modal-header">
                <h2>{selectedPost.title}</h2>
                <button
                  onClick={handleCloseModal}
                  className="modal-close-button"
                  aria-label="Close modal"
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <p className="job-type-full">
                  <strong>Job Type:</strong> {selectedPost.jobType}
                </p>
                <div
                  className="job-description"
                  dangerouslySetInnerHTML={{ __html: selectedPost.fullContent }}
                />
              </div>
              <div className="modal-footer">
                <button onClick={handleCloseModal}>Close</button>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="form-styles" id="ApplyNow">
        <div className="form-sec-main ">
          <div className="wrapper">
            <h2 className="text-center">Apply Now</h2>

            <form
              onSubmit={handleSubmit}
              encType="multipart/form-data"
              className="careerform"
            >
              <div className="form-sec-1">
                <b>First Name</b>
                <input
                  className="text-1"
                  type="text"
                  placeholder="Enter Your First Name"
                  value={fname}
                  name="fname"
                  id="fname"
                  onChange={(e) => handleChange(e, "fname")}
                />
                {errors.fname && <span className="error">{errors.fname}</span>}
              </div>
              <div className="form-sec-1">
                <b>Last Name</b>
                <input
                  className="text-1"
                  type="text"
                  placeholder="Enter Your Last Name"
                  value={lname}
                  name="lname"
                  id="lname"
                  onChange={(e) => handleChange(e, "lname")}
                />
                {errors.lname && <span className="error">{errors.lname}</span>}
              </div>
              <div className="form-sec-1">
                <b>Email Id</b>
                <input
                  className="text-1"
                  placeholder="Enter Your Email*"
                  type="email"
                  value={email}
                  name="email"
                  id="email"
                  onChange={(e) => handleChange(e, "email")}
                />
                {errors.email && <span className="error">{errors.email}</span>}
              </div>
              <div className="form-sec-1 border-1">
                <b>Phone Number</b>
                <PhoneInput
                  country={"in"}
                  value={phone}
                  onChange={(phone) => setPhone(phone)}
                  inputProps={{
                    name: "phone",
                    required: true,
                    autoFocus: true,
                  }}
                />
                {errors.phone && <span className="error">{errors.phone}</span>}
              </div>
              <div className="form-sec-1">
                <b>Qualification</b>
                <input
                  className="text-1"
                  type="text"
                  placeholder="Your Qualification"
                  value={qualification}
                  name="qualification"
                  id="qualification"
                  onChange={(e) => handleChange(e, "qualification")}
                />
                {errors.qualification && (
                  <span className="error">{errors.qualification}</span>
                )}
              </div>
              <div className="form-sec-1">
                <b>Experience</b>
                <input
                  className="text-1"
                  type="text"
                  placeholder="Your Experience"
                  value={experience}
                  name="experience"
                  id="experience"
                  onChange={(e) => handleChange(e, "experience")}
                />
                {errors.experience && (
                  <span className="error">{errors.experience}</span>
                )}
              </div>
              <div className="form-sec-1">
                <b>Job Category</b>
                <input
                  className="text-1"
                  type="text"
                  placeholder="Enter Job Category"
                  value={jobCategory} // Bind to jobCategory state
                  name="jobCategory"
                  id="jobCategory"
                  onChange={(e) => handleChange(e, "jobCategory")} // Update jobCategory on change
                />
                {errors.jobCategory && (
                  <span className="error">{errors.jobCategory}</span>
                )}
              </div>
              <div className="form-sec-1">
                <b>Address</b>
                <input
                  className="text-1"
                  type="text"
                  placeholder="Your Address"
                  value={address}
                  name="address"
                  id="address"
                  onChange={(e) => handleChange(e, "address")}
                />
                {errors.address && (
                  <span className="error">{errors.address}</span>
                )}
              </div>
              <div className="form-sec-1 w-100">
                <b>Other Information</b>
                <textarea
                  className="textarea-1"
                  placeholder="Message"
                  value={otherinformation}
                  name="otherinformation"
                  id="otherinformation"
                  onChange={(e) => handleChange(e, "otherinformation")}
                />
              </div>

              <div className="form-sec-1 w-100">
                <b>Upload Resume</b>
                <input
                  className="text-2"
                  type="file"
                  name="resume"
                  id="resume"
                  onChange={onChangeFileUpload}
                />
                {errors.resume && (
                  <span className="error">{errors.resume}</span>
                )}
              </div>

              <div className="form-sec-1 w-100">
                <button type="submit" value="Submit" className="button-1">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Careers;
